<app-question-base [question]="question" [isFirstQuestion]="isFirstQuestion">
  <div class="flex gap-4 flex-col" [formGroup]="form">
    @for (row of question.rows; track $index) {
      @if (row.presentation === "DROPDOWN" && form.get(row.id)) {
        <div>
          <label
            class="font-normal text-lg leading-normal mb-2 text-inherit"
            [for]="row.id"
          >
            {{ row.title }}
          </label>

          <ng-select
            searchable="false"
            [labelForId]="row.id"
            bindLabel="title"
            class="mt-[0.38rem]"
            [formControlName]="row.id"
            clearable="false"
            [attr.title]="getSelectedTitle(row.id)"
            [attr.aria-label]="row.title"
            [attr.aria-expanded]="dropdownStates[$index]"
            (open)="dropdownStates[$index] = true"
            (close)="dropdownStates[$index] = false"
            (change)="handleOnChange()"
            [placeholder]="
              'question.singleselectdropdown.placeholder' | translate
            "
          >
            <ng-template ng-label-tmp let-clear="clear">
              <span
                class="dropdown-selected-label"
                [title]="getSelectedTitle(row.id)"
              >
                {{
                  getSelectedTitle(row.id) ||
                    ('question.singleselectdropdown.placeholder' | translate)
                }}
              </span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              @if (item === "") {
                {{ "question.singleselectdropdown.placeholder" | translate }}
              } @else {
                {{ getAlternativeTitle(row, item) }}
              }
            </ng-template>

            <ng-option class="flex flex-row" [value]="''">
              <span class="dropdown-option-label">
                {{ "question.singleselectdropdown.placeholder" | translate }}
              </span>
            </ng-option>

            @for (alternative of row.alternatives; track $index) {
              <ng-option
                class="flex flex-row"
                [ariaDisabled]="alternative.disabled ? 'true' : 'false'"
                [disabled]="alternative.disabled"
                [value]="alternative.id"
              >
                <span class="dropdown-option-label">
                  {{ alternative.title }}
                </span>
              </ng-option>
            }
          </ng-select>
          @if (form.get(row.id)?.invalid && form.get(row.id)?.touched) {
            <app-validator
              [question]="row"
              [validator]="validatorType.RequiredSelect"
            ></app-validator>
          }
        </div>
      }
    }
  </div>
</app-question-base>
